import { useEffect, useState } from "react";
import { CustomerDetailsViewModel } from "../../../viewmodels/customers/customer/CustomerDetailsViewModel";

import { useLocation } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { classNames, getLastItem, withRouter } from "../../../shared/utility";

import CustomerDetailsForm from "../../../components/forms/customer/CustomerDetailsForm";
import CustomerAddressesForm from "../../../components/forms/customer/CustomerAddressesForm";
import EmptyModal from "../../../components/modals/EmptyModal";
import type { AppDispatch, RootState } from "../../../index";

const tabs = [
  { name: "Customer Details", href: "#" },
  { name: "Address", href: "#" },
  { name: "Analytics", href: "#" },
];

interface CustomerDetailsProps { logout: () => void }

function CustomerDetails(props: CustomerDetailsProps) {
  const { logout } = props;

  const [currentTab, setCurrentTab] = useState(0);

  const { pathname } = useLocation();
  const customerId = getLastItem(pathname);

  const {
    customerGroupOptions,
    getCustomerGroupsForDropdown,
    updateCustomer,
    getCustomer,
    customer,
    loading,
    getUsersForDropdown,
    usersOptions,
    taxRateOptions,
    getTaxRatesForDropdown,
    emptyModal,
    setEmptyModelOpen,
  } = CustomerDetailsViewModel(logout, customerId);

  const onStartDependencides = async function () {
    await getCustomerGroupsForDropdown();
    await getUsersForDropdown();
    await getTaxRatesForDropdown();
    await getCustomer();
  };

  useEffect(() => {
    onStartDependencides();
  }, []);

  const renderComponent = (index: number) => {
    switch (index) {
      case 0:
        return (
          <div key={0} className="-mt-2 bg-white rounded-lg">
            {loading || !customer ? (
              <div className="flex flex-col items-center justify-center py-12">
                <ProgressSpinner
                  style={{ width: "50px", height: "50px" }}
                  strokeWidth="4"
                  fill="transparent"
                  animationDuration="1s"
                />
                <p className="text-body-2 apollo-body mt-4">Loading customer details...</p>
              </div>
            ) : (
              <CustomerDetailsForm
                customerGroupOptions={customerGroupOptions}
                customer={customer}
                actionCall={updateCustomer}
                usersOptions={usersOptions}
                taxRateOptions={taxRateOptions}
              />
            )}
          </div>
        );

      case 1:
        return (
          <div key={1} className="-mt-2 bg-white rounded-lg">
            {loading || !customer ? (
              <div className="flex flex-col items-center justify-center py-12">
                <ProgressSpinner
                  style={{ width: "50px", height: "50px" }}
                  strokeWidth="4"
                  fill="transparent"
                  animationDuration="1s"
                />
                <p className="text-body-2 apollo-body mt-4">Loading customer details...</p>
              </div>
            ) : (
              <CustomerAddressesForm
                billing_address={customer.billing_address}
                shipping_address={customer.shipping_address}
              />
            )}
          </div>
        );

      case 2:
        return (
          <div key={2} className="-mt-2 bg-white rounded-lg">
            Coming soon
          </div>
        );

      default:
        return (
          <div key={1000} className="-mt-2 bg-white">
            Could not load page, please try again
          </div>
        );
    }
  };

  return (
    <div>
      <main>
        {/* max-w-7xl mx-auto */}
        <div className="py-6 sm:px-6 lg:px-8">
          {/* Content starts here */}

          {/* tab here */}
          <div>
            <div className="sm:hidden">
              <label htmlFor="tabs" className="sr-only">
                Select a tab
              </label>
              <select
                id="tabs"
                name="tabs"
                className="block w-full  border-gray-300 rounded-md"
                defaultValue={tabs[currentTab].name}
              >
                {tabs.map((tab, index) => (
                  <option key={index}>{tab.name}</option>
                ))}
              </select>
            </div>
            <div className="hidden sm:block">
              <nav
                className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
                aria-label="Tabs"
              >
                {tabs.map((tab, index) => (
                  <a
                    key={tab.name}
                    href={tab.href}
                    className={classNames(
                      index === currentTab ? "text-gray-900" : "text-gray-500 hover:text-gray-700",
                      index === 0 ? "rounded-l-lg" : "",
                      index === tabs.length - 1 ? "rounded-r-lg" : "",
                      "group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                    )}
                    aria-current={index === currentTab ? "page" : undefined}
                    onClick={() => setCurrentTab(index)}
                  >
                    <span>{tab.name}</span>
                    <span
                      aria-hidden="true"
                      className={classNames(
                        index === currentTab ? "bg-indigo-500" : "bg-transparent",
                        "absolute inset-x-0 bottom-0 h-0.5"
                      )}
                    />
                  </a>
                ))}
              </nav>
            </div>
          </div>

          {/* {tab content starts below} */}
          <div className="px-4 py-6 sm:px-0 rounded-3xl">
            <div className="sm:col-span-9 rounded-3xl">
              {tabs.map((item, index) => (index === currentTab ? renderComponent(index) : null))}
            </div>
          </div>
        </div>
        <EmptyModal
          childComponent={emptyModal.childComponent}
          open={emptyModal.open}
          setOpen={setEmptyModelOpen}
        />
      </main>
    </div>
  );
}

const mapStateToProps = (_state: RootState) => {
  return {};
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerDetails));
